// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
//欢迎页
import welcome from "@/views/welcome";
// 用户管理
import User from '@/views/system/User';
//帖子列表
import posts from '@/views/posts/posts';
//轮播图片
import banner from '@/views/banner/banner';
//消息通知
import commonMsg from '@/views/commonMsg/commonMsg'
//优惠券管理
import coupon from '@/views/order/coupon';
//跑腿订单管理
import runErrands from '@/views/order/runErrands';
//支付订单
import order from '@/views/order/order';
//提现申请
import commissionExtract from '@/views/order/commissionExtract';
/**
 * 基础菜单
 */
// 佣金比例管理
import Commission from '@/views/hotel/Commission';
// 订单佣金管理
import OrderCommission from '@/views/hotel/OrderCommission';
// 酒店管理
import Hotel from '@/views/hotel/Hotel';
// 客房管理
import Room from '@/views/hotel/Room';

//首页图片
import Images from "@/views/hotel/Images"
/**
 * 系统管理
 */

// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
//字典管理
import Dict from '@/views/system/Dict'
//用户说明
import Explain from "@/views/system/Explain";


/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [{
    path: '/',
    name: '',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/login',
    name: '登录',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/index',
    name: '首页',
    component: index,
    redirect: '/welcome',
    iconCls: 'el-icon-tickets',
    children: [{
      path: '/welcome',
      name: '欢迎页',
      component: welcome,
      meta: {
        requireAuth: false
      }
    }, {
      path: '/hotel/Commission',
      name: '佣金管理',
      component: Commission,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/hotel/OrderCommission',
      name: '订单佣金管理',
      component: OrderCommission,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/hotel/Hotel',
      name: '酒店管理',
      component: Hotel,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/hotel/Room',
      name: '客房管理',
      component: Room,
      meta: {
        requireAuth: true
      }
    },{
      path: '/system/User',
      name: '用户管理',
      component: User,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/Module',
      name: '菜单管理',
      component: Module,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/Role',
      name: '角色管理',
      component: Role,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/Dict',
      name: '字典管理',
      component: Dict,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/system/Explain',
      name: '用户说明',
      component: Explain,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/hotel/Images',
      name: '首页图片',
      component: Images,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/charts/statistics',
      name: '数据可视化',
      component: statistics,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/posts/posts',
      name: '帖子管理',
      component: posts,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/banner/banner',
      name: '轮播图片管理',
      component: banner,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/commonMsg/commonMsg',
      name: '消息通知管理',
      component: commonMsg,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/order/coupon',
      name: '优惠券管理',
      component: coupon,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/order/runErrands',
      name: '跑腿订单管理',
      component: runErrands,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/order/order',
      name: '订单管理',
      component: order,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/order/commissionExtract',
      name: '佣金提现管理',
      component: commissionExtract,
      meta: {
        requireAuth: true
      }
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js